// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/style-loader!./~/css-loader!/opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib/loaders/stylePostLoader.js!/opt/HistomicsUI/histomicsui/web_client/~/vue-loader/lib?{}!./~/@girder/histomicsui/vue/components/ColorPickerInput.vue?vue&type=style&index=0&id=65c96cfc&scoped=true&lang=css&
// module id = 142
// module chunks = 0